export type FocusVisibilityState = 'visible' | 'hidden'

export type FocusEventKind = 'TabHidden' | 'TabVisible' | 'WindowBlur' | 'WindowFocus'

export interface FocusMonitorState {
    tabHidden: boolean
    justEmittedTabVisible: boolean
}

export function createFocusMonitorState(): FocusMonitorState {
    return { tabHidden: false, justEmittedTabVisible: false }
}

export function getFocusEventsFromVisibilityChange(
    visibilityState: FocusVisibilityState,
    state: FocusMonitorState
): { events: FocusEventKind[]; nextState: FocusMonitorState } {
    if (visibilityState === 'hidden') {
        return {
            events: ['TabHidden'],
            nextState: { ...state, tabHidden: true, justEmittedTabVisible: false },
        }
    }

    return {
        events: ['TabVisible'],
        nextState: { ...state, tabHidden: false, justEmittedTabVisible: true },
    }
}

export function getFocusEventsFromBlur(
    visibilityState: FocusVisibilityState,
    state: FocusMonitorState
): { events: FocusEventKind[]; nextState: FocusMonitorState } {
    if (visibilityState === 'hidden' || state.tabHidden) {
        return { events: [], nextState: state }
    }

    return { events: ['WindowBlur'], nextState: state }
}

export function getFocusEventsFromFocus(
    visibilityState: FocusVisibilityState,
    state: FocusMonitorState
): { events: FocusEventKind[]; nextState: FocusMonitorState } {
    if (visibilityState !== 'visible') {
        return { events: [], nextState: state }
    }

    if (state.justEmittedTabVisible) {
        return { events: [], nextState: { ...state, justEmittedTabVisible: false } }
    }

    return { events: ['WindowFocus'], nextState: state }
}

export function getFocusEventsFromPageHide(state: FocusMonitorState): { events: FocusEventKind[]; nextState: FocusMonitorState } {
    return {
        events: ['TabHidden'],
        nextState: { ...state, tabHidden: true, justEmittedTabVisible: false },
    }
}
